export enum ObjectLoadStrategy {
  FromMemory,
  FromServer,
  FromLocalStorage
}